import React from 'react';
import { Stepper, Step } from 'react-form-stepper';
import './CustomStepper.css'; // Import the CSS file

const CustomStepper = ({ currentStep, steps }) => {
  return (
    <div className="bg-white shadow-xl rounded-2xl w-full px-[104px] font-vistra">
      <Stepper
        activeStep={currentStep}
        connectorStateColors
        connectorStyleConfig={{
          activeColor: '#2670FF',
          completedColor: '#1C7D29',
          disabledColor: '#E4E8EF',
          size: 2,
        }}
        styleConfig={{
          activeBgColor: '#2670FF',
          completedBgColor: '#1C7D29',
          inactiveBgColor: '#E4E8EF',
          inactiveTextColor: '#6b7280',
          activeTextColor: '#ffffff',
          completedTextColor: '#ffffff',
          size: '1.5rem',
        }}
        stepClassName="custom-step"
      >
        {steps.map((data) => (
          <Step key={data.label} label={data.label} />
        ))}
      </Stepper>

    </div>
  );
};

export default CustomStepper;
